export default {
  namespaced: true,
  state: {
    roleId: 0
  },
  mutations: {
    SET_ROLE_ID(state, roleId) {
      state.roleId = roleId
    }
  },
  actions: {
    setRoleId({ commit }, roleId) {
      commit('SET_ROLE_ID', roleId)
      return roleId
    }
  }
}
